import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, OnInit } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CUSTOM_NAVBAR_MENU } from './constants/nav-bar-menu.constant';
import { CustomNavBarMenu, ExampleFlatNode } from './models/nav-bar.model';
import { GlobalService } from './services/global.service';
import { LocalStorageService } from './services/local-storage.service';
import { KeycloakService } from '@inoventoryapps/keycloak-angular';
import { UserDetails } from './models/keycloak.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})


export class AppComponent implements OnInit {
  public _transformer = (node: CustomNavBarMenu, level: number) => {
    return {
      expandable: !!node.dropDownList && node.dropDownList.length > 0,
      name: node.title,
      level: level,
      icon: node.icon || '',
      routerLinkUrl: node.routerLinkUrl || ''
    };
  };

  userDetails: any
  permissionMappedRaw: any
  public isOpsCompleted: boolean = false
  ngOnInit(): void {
    (async () => {
      const userInfo: any = await this.gs.getUserInfo();
      this.gs.clearSensitiveUserContext();

      const geoMap: any = { block: '', district: '', state: '', national: '' };
      const enrichedRoles: string[] = [];
      let hasBlockCadreIB = false;
      const selectedRoleFromUrl = this.gs.getSelectedRoleFromUrl();

      for (const key in userInfo.resource_access) {
        const [prefix, geoId] = key.split('-');
        const roleList = userInfo.resource_access[key].roles;

        if (['b', 'd', 's', 'n'].includes(prefix.toLowerCase()) && geoId) {
          for (const role of roleList) {
            const roleLower = role.toLowerCase();
            if (roleLower === 'block-cadre-ib') {
              hasBlockCadreIB = true;
            }

            if (
              roleLower.startsWith('block-manager') ||
              roleLower.startsWith('district-manager') ||
              roleLower.startsWith('state-manager') ||
              roleLower.startsWith('national-manager') ||
              roleLower === 'block-administrator' ||
              roleLower === 'district-administrator' ||
              roleLower === 'state-administrator' ||
              roleLower === 'national-administrator'
            ) {
              enrichedRoles.push(`${role}(${geoId})`);

              if (
                (roleLower.startsWith('block-manager') || roleLower === 'block-administrator')
                && !geoMap.block
              ) geoMap.block = key;
              else if (
                roleLower.startsWith('district-manager') ||
                roleLower.startsWith('district-program') ||
                roleLower.startsWith('district-administrator')
              ) {
                geoMap.district = key;
              }
              else if (
                (roleLower.startsWith('state-manager') || roleLower === 'state-administrator')
                && !geoMap.state
              ) geoMap.state = key;
              else if (
                (roleLower.startsWith('national-manager') || roleLower === 'national-administrator')
                && !geoMap.national
              ) geoMap.national = key;
            }

          }
        }
      }

      let activeRole = '';
      let geoInput: any = {};
      if (geoMap.block) {
        activeRole = 'block';
        geoInput.blockId = geoMap.block;
      } else if (geoMap.district) {
        activeRole = 'district';
        geoInput.districtId = geoMap.district;
      } else if (geoMap.state) {
        activeRole = 'state';
        geoInput.stateId = geoMap.state;
      } else if (geoMap.national) {
        activeRole = 'national';
        geoInput.nationalId = geoMap.national;
      }
      this.gs.getGeoLocationAsync().then(() => {
        const normalizedGeo = this.gs.getGeoLocation(geoInput, activeRole);

        // ==========================
        // SORT ROLES ALPHABETICALLY
        // ==========================

        const sortedRoles =
          [...enrichedRoles].sort((a: any, b: any) =>
            a.localeCompare(b)
          );

        const resolvedSelectedRole =
          sortedRoles.find((roleWithGeo: string) => roleWithGeo === selectedRoleFromUrl) ||
          sortedRoles[0] ||
          '';

        const defaultRole =
          resolvedSelectedRole.split('(')[0] || '';

        // ==========================
        // ACTIVE ROLE
        // ==========================

        let selectedRole = '';
        let selectedGeoInput: any = {};

        if (defaultRole.includes('block')) {

          selectedRole = 'block';

          const blockGeo =
            resolvedSelectedRole
              ?.match(/\((.*?)\)/)?.[1];

          selectedGeoInput.blockId = blockGeo;

        }
        else if (defaultRole.includes('district')) {

          selectedRole = 'district';

          const districtGeo =
            resolvedSelectedRole
              ?.match(/\((.*?)\)/)?.[1];

          selectedGeoInput.districtId = districtGeo;

        }
        else if (defaultRole.includes('state')) {

          selectedRole = 'state';

          const stateGeo =
            resolvedSelectedRole
              ?.match(/\((.*?)\)/)?.[1];

          selectedGeoInput.stateId = stateGeo;

        }
        else {

          selectedRole = 'national';

          selectedGeoInput.nationalId = '00';

        }

        // ==========================
        // GEO NORMALIZATION
        // ==========================

        const selectedNormalizedGeo =
          this.gs.getGeoLocation(
            selectedGeoInput,
            selectedRole
          );

        // ==========================
        // FINAL USER DETAILS
        // ==========================

        this.userDetails = {

          role: sortedRoles,

          blockId:
            selectedNormalizedGeo.blockId || '',

          districtId:
            selectedNormalizedGeo.districtId || '',

          stateId:
            selectedNormalizedGeo.stateId || '',

          mobileNumber:
            +userInfo.phone_number,

          tenantId:
            userInfo?.tenant_id,

          userName:
            userInfo.name,

          activeRole:
            selectedRole,

          activeRoleVerticle:
            this.gs.roleConfig[defaultRole]
              ?.verticle,

          fullUserRoleVerticle:
            defaultRole,

          selectedRoleWithGeo:
            resolvedSelectedRole,

          nationalId:
            '00',

          sub:
            userInfo.sub,

          hasBlockCadreIB:
            hasBlockCadreIB

        };
        this.gs.setUserDetails(this.userDetails);

        this.isOpsCompleted = true;
      });

    })();
  }



  treeControl = new FlatTreeControl<ExampleFlatNode>(node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    node => node.level,
    node => node.expandable,
    node => node.dropDownList
  );

  public dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  public title = 'CadreManagementNew';
  public expandedSideNav = true;

  constructor(public router: Router, public translate: TranslateService, public keycloakService: KeycloakService, public gs: GlobalService, public ls: LocalStorageService) {
    this.translate.setDefaultLang('en');
    this.translate.use('en');
    this.dataSource.data = CUSTOM_NAVBAR_MENU;
    // this.getUserInfo()
  }

  // async getUserInfo() {
  //     try {
  //         let info: any = await this.gs.getUserInfo().toPromise()
  //         this.ls.set('role', info.groups[0])
  //         // console.log(info)
  //     } catch (error) {
  //         console.log(error)
  //     }
  // }

  public hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  public isActive(node: string): boolean {
    if (node) {
      return this.router.url.includes(node);
    }
    return false;
  }

  public isLoggedIn() {
    return true;
  }


}
